<template>
  <c-form
    required-fields
    @submit.prevent="submit"
  >
    <p>Bitte kopieren Sie keine Tabellen in die Formularfelder.</p>

    <c-form-fieldset
      legend="Allgemeine Angaben"
      detail="(ab der dritten Wettbewerbsphase öffentlich sichtbar)"
    >

      <c-form-input
        id="title"
        :errors="[{
          message: 'Dieses Feld ist erforderlich.',
          show: !$v.title.required
        }, {
          message: `Bitte nicht mehr als ${$v.title.$params.maxLength.max} Zeichen.`,
          show: !$v.abstract.maxLength
        }]"
        :has-error="$v.title.$error"
        :is-valid="!$v.title.$invalid"
        :label="'Titel (max. ' + $v.title.$params.maxLength.max + ' Zeichen) *'"
        v-model="title"
        aria-required="true"
        @input="$v.title.$touch"
      />

      <ckeditor
        id="text"
        v-model="abstract"
        :errors="[{
          message: 'Dieses Feld ist erforderlich.',
          show: !$v.abstract.required
        }, {
          message: `Bitte nicht mehr als ${$v.abstract.$params.maxLength.max} Zeichen.`,
          show: !$v.abstract.maxLength
        }]"
        :has-error="$v.abstract.$error"
        :is-valid="!$v.abstract.$invalid"
        label="Kurzbeschreibung"
        @input="$v.abstract.$touch"
      />

      <img
        v-if="image"
        :src="tempImage"
        width="150"
        height="150"
      >
      <p v-else>Kein Bild hinterlegt.</p>

      <c-form-input
        id="image"
        ref="image"
        accept=".jpg,.jpeg,.png"
        label="Bild (JPEG, PNG)"
        type="file"
        @change="changeImage($event[0])"
      />

      <ckeditor
        id="text"
        v-model="description"
        :errors="[{
          message: 'Dieses Feld ist erforderlich.',
          show: !$v.description.required
        }, {
          message: `Bitte nicht mehr als ${$v.description.$params.maxLength.max} Zeichen.`,
          show: !$v.description.maxLength
        }]"
        :has-error="$v.description.$error"
        :is-valid="!$v.description.$invalid"
        label="Beschreibung *"
        @input="$v.description.$touch"
      />

    </c-form-fieldset>

    <c-form-fieldset
      legend="Projektdetails"
      detail="(nur für stiftungsinterne Zwecke)"
    >

      <ckeditor
        id="text"
        v-model="collaborators"
        :errors="[{
          message: 'Dieses Feld ist erforderlich.',
          show: !$v.collaborators.required
        }, {
          message: `Bitte nicht mehr als ${$v.collaborators.$params.maxLength.max} Zeichen. *`,
          show: !$v.collaborators.maxLength
        }]"
        :has-error="$v.collaborators.$error"
        :is-valid="!$v.collaborators.$invalid"
        label="Beteiligte und Zielgruppen (max. 6000 Zeichen) *"
        @input="$v.collaborators.$touch"
      />

      <ckeditor
        id="text"
        v-model="financePlan"
        :errors="[{
          message: 'Dieses Feld ist erforderlich.',
          show: !$v.financePlan.required
        }, {
          message: `Bitte nicht mehr als ${$v.financePlan.$params.maxLength.max} Zeichen. *`,
          show: !$v.financePlan.maxLength
        }]"
        :has-error="$v.financePlan.$error"
        :is-valid="!$v.financePlan.$invalid"
        :label="'Finanzaufstellung (max. ' + $v.financePlan.$params.maxLength.max + ' Zeichen) *'"
        @input="$v.financePlan.$touch"
      />

      <c-form-input
        id="finance-needed"
        :errors="[{
          message: 'Dieses Feld ist erforderlich.',
          show: !$v.financeNeeded.required
        }, {
          message: 'Bitte geben Sie eine Zahl ein.',
          show: !$v.financeNeeded.minValue || !$v.financeNeeded.numeric
        }]"
        :has-error="$v.financeNeeded.$error"
        :is-valid="!$v.financeNeeded.$invalid"
        v-model="financeNeeded"
        aria-required="true"
        label="Finanzbedarf (in Euro) *"
        min="0"
        step="1"
        type="number"
        @input="$v.financeNeeded.$touch"
      />

      <c-form-input
        id="team"
        :errors="[{
          message: `Bitte nicht mehr als ${$v.team.$params.maxLength.max} Zeichen.`,
          show: !$v.team.maxLength
        }]"
        :has-error="$v.team.$error"
        :is-valid="!$v.team.$invalid"
        :label="'Weitere Teammitglieder (max. ' + $v.team.$params.maxLength.max + ' Zeichen)'"
        v-model="team"
        @input="$v.team.$touch"
      />

      <ckeditor
        id="text"
        v-model="timeAllocation"
        :errors="[{
          message: 'Dieses Feld ist erforderlich.',
          show: !$v.timeAllocation.required
        }, {
          message: `Bitte nicht mehr als ${$v.timeAllocation.$params.maxLength.max} Zeichen. *`,
          show: !$v.timeAllocation.maxLength
        }]"
        :has-error="$v.timeAllocation.$error"
        :is-valid="!$v.timeAllocation.$invalid"
        :label="'Zeitplan/Dauer (max. ' + $v.timeAllocation.$params.maxLength.max + ' Zeichen) *'"
        @input="$v.timeAllocation.$touch"
      />

      <ckeditor
        id="comment"
        v-model="comment"
        :errors="[{
          message: 'Dieses Feld ist erforderlich.',
          show: !$v.comment.required
        }, {
          message: `Bitte nicht mehr als ${$v.comment.$params.maxLength.max} Zeichen. *`,
          show: !$v.comment.maxLength
        }]"
        :has-error="$v.comment.$error"
        :is-valid="!$v.comment.$invalid"
        :label="'Kommentar an die Claussen-Simon-Stiftung (max. ' + $v.comment.$params.maxLength.max + ' Zeichen)'"
        @input="$v.comment.$touch"
      />

    </c-form-fieldset>

    <p>Sollten Sie weitere Dokumente (PDF) oder Bilder, ergänzend zu Ihrem Projektvorschlag,
    zur Verfügung stellen wollen, schicken Sie diese bitte an
      <a href="mailto:info@claussen-simon-stiftung.de">
        info@claussen-simon-stiftung.de
      </a>
    </p>

    <c-button :busy="saveStatus === $config.status.SAVING">
      Speichern
    </c-button>

    <p>
      <br>Ihr Projektantrag wird zwischengespeichert. Er bleibt für Sie bis zum Ende der dritten Wettbewerbsphase bearbeitbar.
      Danach können Sie Ihren finalen Projektvorschlag hier exportieren.
    </p>

  </c-form>
</template>

<script>
import CButton from '@/components/CButton'
import CForm from '@/components/form/CForm'
import CFormFieldset from '@/components/form/CFormFieldset'
import CFormInput from '@/components/form/CFormInput'
import CFormTextarea from '@/components/form/CFormTextarea'
import CTitle from '@/components/CTitle'

import { minValue, numeric, required, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'CProjectForm',

  components: {
    CButton,
    CForm,
    CFormFieldset,
    CFormInput,
    CFormTextarea,
    CTitle,
    ckeditor: () => import('@/components/form/CEditor')
  },

  props: {
    data: {
      type: Object
    },
    saveStatus: {
      type: Number
    }
  },

  data () {
    return {
      abstract: '',
      collaborators: '',
      comment: '',
      description: '',
      financeNeeded: null,
      financePlan: '',
      image: null,
      team: '',
      timeAllocation: '',
      title: '',
      tempImage: null,
      imageChanged: false
    }
  },

  validations: {
    title: {
      maxLength: maxLength(300),
      required
    },
    abstract: {
      maxLength: maxLength(4000),
      required
    },
    description: {
      maxLength: maxLength(20000),
      required
    },
    collaborators: {
      maxLength: maxLength(6000),
      required
    },
    financePlan: {
      maxLength: maxLength(6000),
      required
    },
    financeNeeded: {
      minValue: minValue(0),
      numeric,
      required
    },
    timeAllocation: {
      maxLength: maxLength(6000),
      required
    },
    team: {
      maxLength: maxLength(800)
    },
    comment: {
      maxLength: maxLength(2000)
    }
  },

  created () {
    if (this.data) {
      this.abstract = this.data.abstract
      this.collaborators = this.data.collaborators
      this.comment = this.data.comment
      this.description = this.data.description
      this.financeNeeded = this.data.finance_needed
      this.financePlan = this.data.finance_plan
      this.team = this.data.team
      this.timeAllocation = this.data.time_allocation
      this.title = this.data.title
      this.image = this.data.image
      this.tempImage = this.$config.appUrl + this.image
    }
  },

  methods: {
    changeImage (image) {
      if (typeof image === 'undefined') {
        return
      }

      this.image = image
      this.tempImage = URL.createObjectURL(image)
      this.imageChanged = true
    },

    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$store.commit('notifications/add', {
          type: 'error',
          text: 'Bitte füllen Sie alle Felder korrket aus.'
        })

        this.$emit('validation', this.$config.status.ERROR)

        return
      }

      const data = new FormData()

      data.append('abstract', this.abstract)
      data.append('collaborators', this.collaborators)
      data.append('comment', this.comment)
      data.append('description', this.description)
      data.append('finance_needed', parseInt(this.financeNeeded))
      data.append('finance_plan', this.financePlan)
      data.append('school', this.$store.state.user.data.teacherData.school.identifier)
      data.append('team', this.team)
      data.append('time_allocation', this.timeAllocation)
      data.append('title', this.title)

      if (this.imageChanged && this.image) {
        data.append('image', this.image, this.image.name)
      }

      this.$emit('validation', this.$config.status.SUCCESS)
      this.$emit('submit', data)
    }
  }
}
</script>
